<template>
  <div class="icon-service-strategy">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 130 130"
      xmlns="http://www.w3.org/2000/svg"
    >

      <g
        transform="translate(-329 -34)"
        stroke="#FFF"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
      >

        <ellipse
          cx="394"
          cy="98"
          rx="55"
          ry="55"
          stroke-dasharray="345.02 345.02"
          stroke-dashoffset="345.02"
        />

        <path
          d="M392.375 129.5h2.25"
          stroke-linecap="square"
          stroke-dasharray="2.25 2.25"
          stroke-dashoffset="2.25"
        />
        <!-- eslint-disable max-len -->

        <path
          class="icon-service-strategy__beams"
          d="M366.545 98h-9.09M430.545 98h-9.09M394 61.455v9.09M374.587 78.587l-6.429-6.429M419.842 123.842l-6.429-6.429M413.413 78.587l6.429-6.429M368.158 123.842l6.429-6.429"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="63.63 63.63"
          stroke-dashoffset="63.63"
        />

        <path
          d="M392 75.641c-11.236 0-20.359 9.012-20.359 20.174 0 8.802 5.59 17.093 13.539 19.911v7.828c0 3.245 2.553 5.946 5.82 5.946v2.5c0 1.383 1.108 2.5 2.5 2.5s2.5-1.117 2.5-2.5v-2.5c3.267 0 6.103-2.7 6.103-5.946v-7.828c7.954-2.815 13.538-11.106 13.538-19.911 0-11.162-9.072-20.174-20.308-20.174H392z"
          stroke-dasharray="165.39 165.39"
          stroke-dashoffset="165.39"
        />
        <!-- eslint-enable max-len -->
        <path
          d="M387 122h13.556"
          stroke-linecap="square"
          stroke-dasharray="13.56 13.56"
          stroke-dashoffset="13.56"
        />

      </g>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconServiceStrategy'
};
</script>

<style lang="scss" src="@/assets/icons/icon-service-strategy-view.scss"></style>



// WEBPACK FOOTER //
// icon-service-strategy-view.vue